import { render, staticRenderFns } from "./moneyPayIntegral.vue?vue&type=template&id=db0548a0&scoped=true"
import script from "./moneyPayIntegral.vue?vue&type=script&lang=js"
export * from "./moneyPayIntegral.vue?vue&type=script&lang=js"
import style0 from "./moneyPayIntegral.vue?vue&type=style&index=0&id=db0548a0&prod&lang=scss&scoped=true"
import style1 from "./moneyPayIntegral.vue?vue&type=style&index=1&id=db0548a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0548a0",
  null
  
)

export default component.exports